import { render, staticRenderFns } from "./NotReceivedCampaignsTable.vue?vue&type=template&id=f1f73afc&scoped=true"
import script from "./NotReceivedCampaignsTable.vue?vue&type=script&lang=js"
export * from "./NotReceivedCampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./NotReceivedCampaignsTable.vue?vue&type=style&index=0&id=f1f73afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f73afc",
  null
  
)

export default component.exports